import {TAuthAccess} from '../types/auth.type'

const getAuthAccess = (): TAuthAccess | null => {
  const userString = localStorage.getItem('user-access')
  if (!userString) {
    return null
  }
  return JSON.parse(userString)
}

const getUserId = (): string | null => {
  const user = getAuthAccess()
  if (!user) {
    return null
  }
  return user.id
}

const setAuthAccess = (access: TAuthAccess | null): void => {
  localStorage.setItem('user-access', JSON.stringify(access))
}

const removeUser = (): void => {
  localStorage.removeItem('user-access')
}

const getLocalRefreshToken = (): string | null => {
  const access = getAuthAccess()
  return access ? access.refreshToken : null
}

const updateAuthTokens = (accessToken: string, refreshToken: string): void => {
  const access = getAuthAccess()
  if (access) {
    access.accessToken = accessToken
    access.refreshToken = refreshToken
    localStorage.setItem('user-access', JSON.stringify(access))
  }
}

export const StorageService = {
  getLocalRefreshToken,
  updateAuthTokens,
  getAuthAccess,
  getUserId,
  setAuthAccess,
  removeUser,
}
